import { useRequest } from '../../network';

const { REACT_APP_API_URL } = process.env;

const editServiceUrl = `${REACT_APP_API_URL}/service`;

const useEditService = () => {
  const { patch } = useRequest();

  const editService = ({ id, params, onStart, onSuccess, onError }) => {
    onStart();
    patch({ url: `${editServiceUrl}/${id}`, body: params })
      .then(onSuccess)
      .catch(onError);
  };

  return { editService };
};

export default useEditService;
